<script setup>

const props = defineProps({
    metadata: Array,
})

const dialogModel = defineModel()

</script>

<template>
    <v-card
        width="600"
        title="Detalhes do Item Personalizavel"
    >
        <template v-slot:text>
            <v-row>
                <v-col md="6">
                    <v-text-field
                        label="Ano selecionado:"
                        v-model="metadata.customizableYear"
                        readonly
                    ></v-text-field>
                </v-col>
                <v-col md="6">
                    <v-text-field
                        label="Mes selecionado:"
                        v-model="metadata.customizableMonth"
                        readonly
                    ></v-text-field>
                </v-col>
                <v-col md="6">
                    <v-text-field
                        label="Nome do corretor:"
                        v-model="metadata.customizableName"
                        readonly
                    ></v-text-field>
                </v-col>
                <v-col md="6" v-if="metadata.customizableTemplate">
                    <v-text-field
                        label="Template escolhido:"
                        :model-value="`${metadata.customizableTemplate} Anos`"
                        readonly
                    ></v-text-field>
                </v-col>
                <v-col md="6">
                    <p>Imagem Importada</p>
                    <v-img
                        :src="metadata.customizableImage.url"
                        width="150px"
                    />
                </v-col>
            </v-row>
        </template>
        <template v-slot:actions>
            <v-btn
                class="ms-auto"
                text="Ok"
                @click="dialogModel = false"
            ></v-btn>
        </template>
    </v-card>

</template>

<style scoped>

</style>